import { RecursivePartial } from '../base';
import { BaseLayoutElement } from './_base-element';
import { LayoutElementType } from './layout-element-type';

export class MenuButtonElement extends BaseLayoutElement {
    type: LayoutElementType.MenuButton  = LayoutElementType.MenuButton;

    icon?: string = 'vzi-3dots';
    text?: string;
    vzType?: 'primary' | 'default' | 'dashed' | 'link' | 'text' | null
    vzShape?: 'circle' | 'round' | null;
    vzSize?: 'large' | 'default' | 'small';
    tooltip?: string = '';
    mobileOnly?: boolean;
    data?: any;

    constructor(json?: RecursivePartial<MenuButtonElement>) {
        super(json);
        this.parseIcon(json || {});
    }

    parse(json: RecursivePartial<MenuButtonElement>): MenuButtonElement {
        super.parse(json);
        this.parseIcon(json);
        return this;
    }

    private parseIcon(json: RecursivePartial<MenuButtonElement>): void {
        MenuButtonElement.assignFields<MenuButtonElement>(this, json, [
            'icon',
            'text',
            'vzType',
            'vzShape',
            'vzSize',
            'tooltip',
            'mobileOnly',
            'data'
        ]);
    }

}
